import glfx from 'glfx';

export const fxCanvas = glfx.canvas();
